import React, { Component } from 'react';
import SearchService from '@nmx/utils/dist/services/SearchService/Frontend';
import { newRelicJSError } from '@nmx/utils/dist/utilities/frontend/Analytics/new_relic_helper';

// props: agentnumber - used to fetch the ensemble information
export default class NmEnsemble extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ensemble: {},
      isLoading: false,
    };
  }

  componentWillMount() {
    this.setState({ isLoading: true });
    SearchService.getTeams({
      agentNumber: this.props.agentnumber,
      isEnsemble: true,
    }).then((rsp) => {
      const ensembleData = rsp.data;
      if (ensembleData.length === 1) {
        this.setState({ ensemble: ensembleData[0] }, () => {
          this.setState({ isLoading: false });
        });
      } else {
        this.setState({ isLoading: false });
      }
    }).catch((err) => {
      const error = `An error occurred while fetching ensemble. Error: ${err}`;
      newRelicJSError(error);
      console.error(error);
    });
  }

  render() {
    if (!this.state.isLoading
            && this.state.ensemble.name
            && this.state.ensemble.url) {
      return (
        <h4 className="nm-rep-card--ensemble" >
          <a href={`${this.state.ensemble.url}`} rel='nofollow noopener noreferrer' target='_blank'>{this.state.ensemble.name}</a>
        </h4>
      );
    }
    return false;
  }
}
